import { MocksHelper } from './MocksHelper';
import { TravelMockProvider } from './TravelMockProvider';

/* eslint-disable @typescript-eslint/no-unused-vars */
const travelProvider = new TravelMockProvider();

const TravelMockService = {
  retrieveTravels: () => {
    const data = travelProvider.getTravelResponse();
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },
  retrieveTravelsWithDate: (input: any) => {
    const data = travelProvider.getTravelResponseByDates(
      input.startDate,
      input.endDate,
    );
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },
};
export default TravelMockService;
